import React from 'react';
import { withRouter } from "react-router-dom";
import { Badge, LinkListItem } from "../../ecosystem";
import { titleCase } from "../../../helpers/formatting";

const DrawerProxyItem = ({
    disabled,
    name,
    showViewing,
    linkProps,
    onClick,
    user
}) => {

    const handleOnClick = () => {
        if (onClick) {
            onClick(name, user);
        }
    }

    return (
        <LinkListItem
            disabled={disabled}
            item={{
                ...linkProps,
                as: !linkProps ? <button type='button'></button> : '',
                onClick: handleOnClick
            }}
        >
            <div className="drawer-proxy-item">
                {titleCase(name)}
                {showViewing && <Badge
                    text="Viewing"
                    show={showViewing}
                    disabled={disabled}
                    colorStyle="subtle"></Badge>}
            </div>
        </LinkListItem>
    );
}

export default withRouter(DrawerProxyItem);
